import React from 'react'

const AlarmPage = () => {
  return (
    <div>AlarmPage</div>
  )
}

export default AlarmPage